import React from "react";
import { styled } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import IconAvatarStyled from "../IconAvatarStyled";

const FacebookIconStyled = styled(FacebookIcon)(({ theme }) => ({
  color: theme.palette.brand.facebook,
  fontSize: 24,
}));

export const FacebookIconAvatar: React.FC = () => (
  <IconAvatarStyled alt="Facebook Avatar">
    <FacebookIconStyled />
  </IconAvatarStyled>
);
